var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"vs-meta vs-text vs-inline-alert",attrs:{"id":_vm.id,"role":"alert","aria-live":"assertive"}},[_c('span',{staticClass:"visa-icon-alert",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }